import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-film-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-foreground-950">
                亚洲国产高清
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              亚洲国产高清是您发现优质亚洲本土影视内容的最佳入口，汇聚亚洲各地国产高清剧集、电影与综艺。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              内容分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                首页
              </Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                关于我们
              </Link>
              <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                常见问题
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-foreground-600 mb-3">
              获取最新影视资讯和精彩推荐
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 亚洲国产高清影视内容精选平台. All rights reserved.
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}